import { useI18n } from '../i18n';
import styles from './HowItGoes.module.css';

/**
 * Four steps. The numerals are Caveat — the spec files index numerals under
 * the handwritten voice, which is what stops a numbered list reading like a
 * form.
 */
export function HowItGoes() {
  const { t } = useI18n();

  return (
    <section className={styles.section} id="how">
      <p className={`caps ${styles.kicker}`}>{t.how.kicker}</p>

      <ol className={styles.list}>
        {t.how.steps.map((step) => (
          <li key={step.no} className={styles.step}>
            <span className={`hand ${styles.no}`}>{step.no}</span>
            <h3 className={styles.title}>{step.title}</h3>
            <p className={styles.body}>{step.body}</p>
          </li>
        ))}
      </ol>
    </section>
  );
}
